import React, { FC } from "react";
import {
    DEFAULT_LISTING_COVER_IMG_SRC,
    PRICE_TAG_IMAGE_SRC,
} from "repoV2/utils/common/assets/assets";
import { getOptimisedImageUrl } from "repoV2/features/Common/modules/ExlyImage/utils/getOptimisedImageUrl";
import styles from "../brandedOfferings.module.scss";
import { IBrandedCommunityOffering } from "./IBrandedCommunityOffering";

const BrandedCommunityOffering: FC<IBrandedCommunityOffering> = ({ item }) => {
    return (
        <div className={styles.card}>
            <div
                className={styles.image}
                style={{
                    backgroundImage: `url(${getOptimisedImageUrl({
                        imageUrl:
                            item.cover_image || DEFAULT_LISTING_COVER_IMG_SRC,
                        fetchWidth: 512,
                    })})`,
                }}
            />
            <div className={styles.amount}>
                <div className={styles.price}>
                    {item.currency} {item.updated_price}
                </div>
            </div>
            <div className={styles.priceTag}>
                <img
                    src={PRICE_TAG_IMAGE_SRC}
                    alt="price-tag"
                    className={styles.tagImage}
                />
            </div>{" "}
            <div className={styles.bonusDiv}>BONUS</div>
            <div className={styles.body}>
                <div className={styles.title}>{item.title}</div>
                <div
                    className={styles.shortDescription}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: item.short_description,
                    }}
                />
            </div>
        </div>
    );
};

export default BrandedCommunityOffering;
